import { openReactConfirmationDialog } from '~commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { Messages } from '~src/codegen/Localize';
import { DomainUpdateType, IUpdateBaasEdgePoolResult } from '~src/settings/dataconnect-settings/serverApi/requests/UpdateBaasEdgePoolRequest';
import { BaasEdgePoolAndCluster } from '~src/settings/dataconnect-settings/serverApi/resources/BaasEdgePoolAndCluster';

import { ActionItemInfo } from '../../MoreActionsMenu';
import { DomainID } from '../../types/Domain';
import { getGeneralErrorMessage } from '../../utils/EdgePoolErrorUtilities';

export function openDeleteDomainConfirmationDialog(deleteDomain: () => void) {
    const dialogInstance = openReactConfirmationDialog({
        title: Messages.dataConnectSiteSettingsDeleteDomain(),
        message: Messages.dataConnectSiteSettingsDeleteDomainConfirmation(),
        paramsForAction: {},
        actionName: Messages.confirm(),
        action: () => {
            deleteDomain();
            return Promise.resolve();
        },
        isActionDelete: true,
        dialogWidth: TabDialogWidth.width375px
    });

    return Promise.resolve(dialogInstance.result);
}

export function openDeletePoolDomainDialog(actionItem: ActionItemInfo) {
    const deleteDomainCallback = () => {
        BaasEdgePoolAndCluster.updateBaasPool({
          poolId: actionItem.poolId,
          displayName: null,
          domainChange: { change: DomainUpdateType.Remove, domainId: actionItem.domain.domainName as DomainID },
          siteId: actionItem.siteId,
          DataConnectSettingsVersion: '0'
        })
          .then((result: IUpdateBaasEdgePoolResult) => {
            actionItem.refreshPoolsAndClusters();
            if (result.success) {
              ToasterService.instance.pop({ type: ToastType.Success, text: Messages.dataConnectSiteSettingsDeleteDomainSuccess() });
            }
            if (result.errors) {
              ToasterService.instance.pop({
                type: ToastType.Error,
                text: getGeneralErrorMessage(result.errors[0].code, result.errors[0].message)
              });
            }
          });
      };
      openDeleteDomainConfirmationDialog(deleteDomainCallback);
}
